module.exports = __webpack_public_path__ + "static/media/front-plank.34be8707.svg";